// extracted by mini-css-extract-plugin
export default {"card":"marketCoinCard_card__lc9Qp","cardHeader":"marketCoinCard_cardHeader__R43O4","cardInfo":"marketCoinCard_cardInfo__RjVZo","priceChange":"marketCoinCard_priceChange__boMow"};